<template>
  <div class="portada-xv" ref="rootRef" aria-label="15th Birthday Cover">

    <!-- SMALL DECORATIVE FLOWERS / BUTTERFLIES WITH FLUTTER EFFECT -->
    <div class="flor-wrapper flor-1">
      <img src="@/assets/mari.png" class="flor aleteo-suave" alt="Decorative butterfly 1" />
    </div>

    <div class="flor-wrapper flor-2">
      <img src="@/assets/mari.png" class="flor aleteo-suave aleteo-delay-1" alt="Decorative butterfly 2" />
    </div>

    <!-- SPINNING DISCO BALL -->
    <img src="@/assets/moñii.png" class="bola bola-izquierda" alt="Disco ball" />

    <!-- CROPPED IMAGE + BOW -->
    <div class="imagen-xv-shell">
      <div class="imagen-xv-wrapper">
        <img
          src="@/assets/4.webp"
          class="imagen-xv"
          alt="Main photo"
        />
      </div>

      <div class="mono-portada">
        <img
          :src="require('@/assets/moñii.png')"
          class="mono-portada-img"
          alt="Decorative bow"
        />
      </div>
    </div>

    <!-- MAIN TITLE (LARGER) -->
    <h1 class="nombre-protagonista2"></h1>

    <!-- MAIN TEXT -->
    <section class="texto-xv">
      <p class="frase-bendicion">
        With the blessing of God <br />
        and my parents:
      </p>

      <div class="separador-elegante"></div>

      <h1 class="nombre-protagonista"> Alejandro Chávez &nbsp;</h1>
      <h1 class="nombre-protagonista"> Raquel Morales</h1>

      <!-- GODPARENTS (INCREASED TEXT) 
      <div class="padrinos">
        <p class="padrinos-titulo">Godparents of Honor</p>
        <p class="padrinos-nombres">Manuel Arrascue <br>Mary Collins-Marmolejo</p>
      </div>
-->
      <p class="parrafo-presentacion"><br>
        There are moments that define our lives, etched forever in our hearts and memories.
        Today, I am experiencing one of those special moments, and I want to share it with those
        who hold a special place in my heart.
      </p>
    </section>
  </div>
</template>

<script>
import { onMounted, ref, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'PortadaArley',
  setup() {
    const rootRef = ref(null)

    onMounted(async () => {
      await nextTick()

      const $ = (sel) => Array.from(gsap.utils.toArray(sel)).filter(Boolean)

      const foto = $('.imagen-xv-shell')
      const tituloMisXv = $('.nombre-protagonista2')
      const flores = ['.flor-1', '.flor-2', '.flor-3'].flatMap($)
      const bola = $('.bola-izquierda')
      const texto = [
        '.frase-bendicion',
        '.separador-elegante',
        '.nombre-protagonista',
        '.padrinos',
        '.parrafo-presentacion'
      ].flatMap($)

      // Configuración inicial
      gsap.set([...foto, ...tituloMisXv, ...flores, ...bola, ...texto], { autoAlpha: 0, y: 30 })

      // Animación progresiva al hacer scroll
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return

          const tl = gsap.timeline({ defaults: { ease: 'power2.out' } })

          tl.fromTo(
            foto,
            { scale: 0.94, y: 40, filter: 'blur(6px)' },
            { autoAlpha: 1, scale: 1, y: 0, filter: 'blur(0)', duration: 1.1 }
          )

          tl.to(tituloMisXv, {
            autoAlpha: 1,
            y: 0,
            duration: 0.8
          }, '-=0.6')

          tl.to(flores, {
            autoAlpha: 1,
            y: 0,
            duration: 0.8,
            stagger: 0.2
          }, '-=0.4')

          tl.to(bola, {
            autoAlpha: 0.85,
            y: 0,
            duration: 0.8
          }, '-=0.4')

          tl.to(texto, {
            autoAlpha: 1,
            y: 0,
            duration: 0.6,
            stagger: 0.12
          }, '-=0.3')

          io.disconnect()
        })
      }, { threshold: 0.2 })

      if (rootRef.value) io.observe(rootRef.value)
    })

    return { rootRef }
  }
}
</script>

<style scoped>
/* CONTENEDOR PRINCIPAL - Sin desbordamientos de ancho */
.portada-xv {
  position: relative;
  width: 100%;
  max-width: 100vw;
  min-height: 100vh;
  background: #f3f7fd;
  overflow-x: hidden;
  overflow-y: visible;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 30px 20px 60px;
  box-sizing: border-box;
}

/* MARCO Y FOTO PRINCIPAL */
.imagen-xv-shell {
  position: relative;
  display: inline-block;
  margin-top: 10px;
}

.imagen-xv-wrapper {
  width: min(80vw, 320px);
  height: calc(min(80vw, 320px) * 1.45);
  border-radius: 180px 180px 0 0;
  overflow: hidden;
  z-index: 2;
  background: #fff;
  box-shadow:
    0 12px 40px rgba(0, 0, 0, .15),
    0 2px 8px rgba(0, 0, 0, .05);
  will-change: transform, filter, opacity;
  position: relative;
}

.imagen-xv {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* MOÑO EN LA FOTO */
.mono-portada {
  position: absolute;
  top: 9px;
  right: -20px;
  z-index: 20;
  transform: rotate(18deg);
  pointer-events: none;
}

.mono-portada-img {
  width: clamp(150px, 28vw, 220px);
  height: auto;
  display: block;
}

/* MARIPOSAS Y FLORES (PEQUEÑAS Y ELEGANTES) */
.flor-wrapper {
  position: absolute;
  z-index: 10;
  perspective: 600px;
}

.flor {
  width: min(16vw, 75px);
  height: auto;
  display: block;
  filter: drop-shadow(0px 4px 8px rgba(0,0,0,0.12));
}

.flor-1 {
  top: 20px;
  left: 4%;
}

.flor-2 {
  top: 240px;
  right: 4%;
}

.flor-3 {
  bottom: 99px !important;
  left: 5%;
}

/* EFECTO DE ALETEO SUAVE EN 3D */
.aleteo-suave {
  animation: aleteoElegante 3.5s ease-in-out infinite alternate;
  transform-origin: center center;
}

.aleteo-delay-1 {
  animation-delay: 0.8s;
}

.aleteo-delay-2 {
  animation-delay: 1.6s;
}

@keyframes aleteoElegante {
  0% {
    transform: rotateY(0deg) translateY(0px) rotate(0deg);
  }
  30% {
    transform: rotateY(32deg) translateY(-4px) rotate(-3deg);
  }
  60% {
    transform: rotateY(8deg) translateY(-2px) rotate(2deg);
  }
  100% {
    transform: rotateY(38deg) translateY(-6px) rotate(-2deg);
  }
}

/* BOLA DISCO Y DECORACIÓN INFERIOR */
.bola {
  position: absolute;
  width: min(22vw, 100px);
  opacity: .85;
  z-index: 1;
  pointer-events: none;
}

.bola-izquierda {
  right: 5%;
  bottom: 80px;
  width: 0px !important;
  animation: girar 12s ease-in-out infinite alternate;
}

@keyframes girar {
  0% { transform: scale(1) rotate(0deg); }
  50% { transform: scale(1.05) rotate(5deg); }
  100% { transform: scale(1) rotate(-5deg); }
}

/* TÍTULO PRINCIPAL - MIS XV */
.nombre-protagonista {
  font-family: "Playfair Display", serif;
  font-size: clamp(20px, 18vw, 30px);
  color: #043b73;
  margin: 5px 0 10px 0;
  line-height: 1;
  text-align: center;
}

/* CONTENEDOR DE TEXTO */
.texto-xv {
  max-width: 680px;
  width: 100%;
  text-align: center;
  margin-top: 5px;
  padding: 0 16px;
  box-sizing: border-box;
}

/* BENDICIÓN (TAMAÑO MÁS GRANDE) */
.frase-bendicion {
  font-family: "Playfair Display", serif;
  font-size: clamp(22px, 3.8vw, 30px);
  color: #2f2e2e;
  line-height: 1.5;
  margin: 15px 0 15px;
  font-weight: 500;
}

.separador-elegante {
  width: 140px;
  height: 3px;
  margin: 18px auto 22px;
  background: linear-gradient(90deg, transparent, #d9b7c6, transparent);
  border-radius: 2px;
}

/* NOMBRES PROTAGONISTAS (MÁS GRANDES Y DESTACADOS) */


/* PADRINOS (MÁS VISIBLES Y AMPLIOS) */
.padrinos {
  margin: 25px 0;
}

.padrinos-titulo {
  font-family: "Playfair Display", serif;
  font-size: clamp(20px, 3.2vw, 28px);
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: #555555;
  margin: 0 0 8px 0;
  font-weight: 600;
}

.padrinos-nombres {
  font-family: "titulos", cursive;
  font-size: clamp(34px, 6.5vw, 46px);
  color: #043b73;
  margin: 0;
  line-height: 1.3;
}

/* PÁRRAFO FINAL (MÁS LEGIBLE) */
.parrafo-presentacion {
  font-family: "quote", sans-serif;
  font-size: clamp(17px, 2.8vw, 21px);
  color: #3d3c3c;
  line-height: 1.8;
  margin-top: 20px;
}

/* RESPONSIVE */
@media (min-width: 992px) {
  .portada-xv {
    padding-top: 50px;
  }
}
</style>